import React from 'react'

const ShippingPolicy = () => {
  return (
    <div></div>
  )
}

export default ShippingPolicy